module.exports = {"230602013":"萨尔图街道","230602014":"会战街道","230602015":"友谊街道","230602016":"东安街道","230602017":"东风街道","230602018":"铁人街道","230602019":"火炬街道","230602020":"拥军街道","230602021":"万宝街道","230602022":"格林街道","230602023":"绿园街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230602.json
// module id = 820
// module chunks = 0